import routeList from '../../routes/routeList';

export default [
  { title: 'Lektury', url: routeList.readings },
  { title: 'Projekty szkolne', url: routeList.projects },
  { title: 'Zgłoś projekt', url: routeList.addProject },
  { title: 'Współpraca', url: routeList.cooperation },
  { title: 'Kontakt', url: routeList.contact }
];
